<div class="price" [class.discounted]="discounted">
{{ quantity * (new_price ? new_price : old_price) | currency:currency }}&nbsp;
</div>	
<div class="price-old" [class.discounted]="discounted" *ngIf="discounted">
	<span class="normal"> {{ quantity * old_price | currency:currency }}</span>
	<span class="discount"> {{ 100 - ((new_price / old_price * 100)) | number: '1.0-1' }}% </span>
</div>